// extracted by mini-css-extract-plugin
export default {"wrap":"TVChart_wrap__0x3J2","toolbar":"TVChart_toolbar__sjY-+","typeBtn":"TVChart_typeBtn__XojAs","active":"TVChart_active__w4yn0"};